// Phase 25 iter-9 — Spanish translation.

export const es = {
  common: {
    cancel: 'Cancelar',
    save: 'Guardar',
    close: 'Cerrar',
    loading: 'Cargando…',
    error: 'Error',
    next: 'Continuar',
    back: 'Volver',
    submit: 'Enviar',
    retry: 'Reintentar',
  },
  language: {
    label: 'Idioma',
    gl: 'Galego',
    es: 'Castellano',
    pt: 'Português',
    en: 'English',
    unavailable: 'Próximamente',
  },
  header: {
    searchPlaceholder: 'Buscar animales por crotal, raza, concello…',
    searchShort: 'Buscar',
    sellCta: 'Vender un animal',
    menuAria: 'Menú de usuario',
    menu: {
      profile: 'Perfil y seguridad',
      purchases: 'Mis compras',
      messages: 'Mensajes',
      kyc: 'Verificación de identidad',
      roles: 'Mis roles',
      shop: 'Tienda LeyroSpot',
      invoices: 'Mis facturas',
      sell: 'Vender un animal',
      admin: 'Administración',
      logout: 'Salir',
      signin: 'Entrar',
      register: 'Crear cuenta',
    },
    notifications: {
      ariaLabel: 'Notificaciones',
      title: 'Notificaciones',
      emptyTitle: 'Aún sin notificaciones',
      emptyBody:
        'Cuando recibas mensajes, ofertas o eventos de tus ventas y compras, aparecerán aquí.',
      markAllRead: 'Marcar todas',
    },
  },
  footer: {
    helpHeading: 'Ayuda',
    helpCenter: 'Centro de ayuda',
    safety: 'Seguridad de la plataforma',
    contactHeading: 'Contacto',
    contactForm: 'Formulario de contacto',
    forFarmers: 'Para ganaderos',
    forBuyers: 'Para compradores',
    leyroSection: 'LeyroChain',
    sellAnimal: 'Vender un animal',
    traceability: 'Trazabilidad digital',
    blockchain: 'Anclaje blockchain',
    eudr: 'EUDR — cumplimiento',
    catalog: 'Explorar animales',
    purchases: 'Mis compras',
    auctions: 'Animales en subasta',
    plans: 'Planes y precio',
    terms: 'Términos de uso',
    privacy: 'Política de privacidad',
    compliance: 'Cumplimiento (EUDR · PEPA)',
    copyright: '© 2026 LeyroChain — Trazabilidad digital del ganado en Galicia.',
    privacyLink: 'Privacidad',
    termsLink: 'Términos',
    sitemap: 'Mapa del sitio',
  },
  cookieBanner: {
    text: 'Solo usamos almacenamiento esencial para que la plataforma funcione (sesión, idioma). Cero analytics, cero tracking.',
    accept: 'Entendido',
    more: 'Detalles',
    ariaLabel: 'Aviso de cookies',
  },
  marketplace: {
    badge: 'Trazabilidad certificada',
    title: 'Confianza en el campo, animal a animal',
    subtitle:
      'Cada animal lleva un historial completo —vacunas, traslados, propietarios— anclado en blockchain pública. Comprar o vender, desde cualquier lugar.',
    typeLabel: 'Tipo',
    provinceLabel: 'Provincia',
    types: {
      ALL: 'Todos',
      BEEF: 'Cárnica',
      DAIRY: 'Lechera',
      BREEDING: 'Reproducción',
      AUCTION: 'Subasta',
    },
    provinces: {
      ALL: 'Toda Galicia',
      A_CORUNA: 'A Coruña',
      LUGO: 'Lugo',
      OURENSE: 'Ourense',
      PONTEVEDRA: 'Pontevedra',
    },
    categoryBar: {
      filters: 'Filtros',
      filtersWithCount: 'Filtros, {{count}} activo',
      filtersDialog: 'Filtros avanzados',
      scrollLeft: 'Desplazar a la izquierda',
      scrollRight: 'Desplazar a la derecha',
    },
    search: 'Buscar',
    salesCount: '{{count}} animales a la venta',
    noResults: 'Ningún animal coincide con los filtros',
    noResultsHint: 'Prueba con menos filtros o vuelve en un rato.',
    sellCta: 'Vender un animal →',
    badges: { auction: 'Subasta', verified: 'Verificada' },
  },
  auth: {
    modal: {
      welcomeLogin: 'Bienvenido de nuevo',
      welcomeRegister: 'Crea tu cuenta',
      tabLogin: 'Entrar',
      tabRegister: 'Crear cuenta',
      forgot: '¿Olvidaste la contraseña?',
      forgotCta: 'Recupera el acceso →',
      orSeparator: 'o',
    },
    fields: {
      email: 'Email',
      name: 'Nombre completo',
      password: 'Contraseña',
      newPassword: 'Contraseña (mín. 8 caracteres)',
      showPassword: 'Mostrar contraseña',
      hidePassword: 'Ocultar contraseña',
    },
    login: { submit: 'Entrar', greet: 'Bienvenido, {{name}}' },
    register: {
      submit: 'Crear cuenta',
      next: 'Continuar',
      terms:
        'Acepto los <terms>Términos de uso</terms> y la <privacy>Política de Privacidad</privacy>.',
      titleRoles: '¿Cómo vas a usar LeyroChain?',
      subtitleRoles:
        'Marca uno o varios. Cada rol puede llevar una verificación específica (KYC). El primero que selecciones será tu rol principal.',
      created: 'Cuenta creada',
      createdBody:
        'Enviamos un correo a {{email}} para que verifiques tu dirección. Revisa la bandeja de entrada y el spam.',
      createdNote:
        'Algunas acciones (vender un animal, firmar como veterinario, etc.) requerirán completar el KYC.',
      primaryBadge: 'Principal',
    },
    errors: {
      invalidEmail: 'Introduce un email válido.',
      passwordTooShort: 'Mínimo 8 caracteres.',
      passwordsMismatch: 'Las contraseñas no coinciden.',
      nameRequired: 'Introduce tu nombre.',
      termsRequired: 'Tienes que aceptar los Términos y la Política de Privacidad.',
      captchaRequired: 'Pasa la verificación anti-bot.',
      rolesRequired: 'Marca al menos un rol para continuar.',
      generic: 'No se pudo completar la operación.',
    },
  },
  billing: {
    title: 'Facturación',
    subtitle: 'Tu plan actual y gestión de pagos.',
    currentPlan: 'Plan actual',
    nextRenewal: 'Se renueva el {{date}}',
    free: 'Free',
    basic: 'Básico',
    pro: 'Pro',
    managePortal: 'Gestionar suscripción',
    portalDesc:
      'Cambia tu tarjeta, consulta facturas y cancela la suscripción desde nuestro portal seguro de pagos.',
    seePlans: 'Ver planes disponibles →',
    notSubscribed: 'Aún no tienes suscripción activa. Echa un vistazo a los planes.',
    invoiceNote: 'Las facturas se envían automáticamente a tu email cuando se procesan los cobros.',
  },
  shop: {
    title: 'Tienda LeyroSpot',
    subtitle:
      'Compra los kits de etiquetas NFC para marcar a tus animales y conectarlos a la cadena LeyroChain.',
    category: 'Tienda',
    price: 'Precio',
    buy: 'Comprar',
    opening: 'Abriendo Stripe…',
    unavailable: 'Este SKU no está disponible en este momento.',
    ordersHeading: 'Mis pedidos',
    trackingLabel: 'Seguimiento',
    status: {
      PENDING_FULFILLMENT: 'Pendiente de envío',
      SHIPPED: 'Enviado',
      DELIVERED: 'Entregado',
      CANCELLED: 'Cancelado',
    },
    errors: {
      load: 'No se pudo cargar la tienda. Vuelve a intentarlo en un momento.',
      checkout: 'No se pudo abrir el pago. Inténtalo de nuevo.',
    },
  },
  shopSuccess: {
    title: 'Pago recibido',
    body: 'Recibimos tu pedido y ya está registrado en tu cuenta.',
    delivery:
      'Los kits se envían por mensajería 24-48h cuando salen del almacén. Recibirás un email con el número de seguimiento.',
    viewOrders: 'Ver mis pedidos',
  },
  shopCancel: {
    title: 'Pago cancelado',
    body: 'Cerraste el pago sin finalizar. No se cobró nada. Puedes volver a intentarlo cuando quieras.',
    retry: 'Volver a la tienda',
  },
} as const;
